angular.module( 'acme.view.application.orders.requests', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.orders.requests.list',
  'acme.view.application.orders.requests.edit',
  'acme.view.application.dataGrid.controllers',
  'acme.view.application.orders.requests.controllers',
  'acme.view.application.orders.requests.modals.removeEvent',
  'acme.view.application.orders.requests.modals.tickets',
  'acme.view.application.orders.requests.modals.scheduleEvent'

])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var ordersRequests = {
        name: 'application.orders.requests',
        url: '/requests',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'OrdersRequestsController',
            templateUrl: 'views/application/views/orders/requests/requests.tpl.html'
          }
        }
      };

    $stateProvider
      .state(ordersRequests);
});
